/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_No_ValueInputs */

const en_us2_progress_no_value = /** @type {(inputs: Progress_No_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`no estimate`)
};

const pt_br2_progress_no_value = /** @type {(inputs: Progress_No_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sem estimativa`)
};

const es_419_progress_no_value = /** @type {(inputs: Progress_No_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sin estimación`)
};

const pt_pt2_progress_no_value = /** @type {(inputs: Progress_No_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sem estimativa`)
};

const fr_fr2_progress_no_value = /** @type {(inputs: Progress_No_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pas d'estimation`)
};

const de_de2_progress_no_value = /** @type {(inputs: Progress_No_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`keine Schätzung`)
};

const it_it2_progress_no_value = /** @type {(inputs: Progress_No_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nessuna stima`)
};

/**
* | output |
* | --- |
* | "no estimate" |
*
* @param {Progress_No_ValueInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_no_value = /** @type {((inputs?: Progress_No_ValueInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_No_ValueInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_no_value(inputs)
	if (locale === "es-419") return es_419_progress_no_value(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_no_value(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_no_value(inputs)
	if (locale === "de-DE") return de_de2_progress_no_value(inputs)
	if (locale === "it-IT") return it_it2_progress_no_value(inputs)
	return en_us2_progress_no_value(inputs)
});
export { progress_no_value as "progress.no_value" }